(() => {
  'use strict';

  let raf = 0;

  function updateCartDrawerOffset() {
    const header = document.querySelector('#header-component');
    const drawer = document.querySelector('#cart-drawer .theme-drawer__dialog');
    if (!drawer) return;

    let top = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 72;
    if (header) {
      const rect = header.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) top = Math.max(0, rect.bottom);
    }

    top = Math.min(Math.max(0, Math.round(top)), Math.max(0, window.innerHeight - 180));
    drawer.style.setProperty('--tp-cart-drawer-top', `${top}px`);
  }

  function scheduleUpdate() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = 0;
      updateCartDrawerOffset();
    });
  }

  document.addEventListener('theme-drawer:open', (event) => {
    if (event.target?.id === 'cart-drawer') scheduleUpdate();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-testid="cart-drawer-trigger"]')) scheduleUpdate();
  }, true);

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('scroll', () => {
    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer?.hasAttribute('open')) scheduleUpdate();
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }
})();
